import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, CheckCircleIcon, ArrowUpRightIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
const PROMISES = ['100% friendly and safe', "We'll respond in 24 hours, fast & focused", 'Work with subject-matter experts'];
export function Footer() {
  return <>
      <section id="contact" className="relative z-10 w-full bg-white px-5 py-20 lg:px-8 lg:py-24" data-id="element-58" data-mp="36n3c3k2n3ksp">
        <div className="mx-auto grid w-full max-w-shell grid-cols-1 gap-12 lg:grid-cols-2" data-id="element-59" data-mp="38h81hlebwon">
          <div className="flex flex-col gap-8" data-id="element-60" data-mp="3lem0o69kenno">
            <h2 className="text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-61" data-mp="3ldu4ouc22nwv">
              Have a Project?
              <br data-id="element-62" data-mp="29zgkq0kfasm4" />
              Let's Talk!
            </h2>
            <ul className="flex flex-col gap-4 text-base text-[#2D2D2D]" data-id="element-63" data-mp="29xvrqfdrbhqd">
              {PROMISES.map(promise => <li key={promise} className="flex items-center gap-3" data-id="element-64" data-mp="2evxaez79tf1b">
                  <CheckCircleIcon className="h-5 w-5 shrink-0 text-[#0000FE]" aria-hidden="true" data-id="element-65" data-mp="3la27gozaktsl" />
                  {promise}
                </li>)}
            </ul>

            <address className="flex flex-col gap-3 not-italic text-sm text-[#595959]" data-id="element-66" data-mp="3q8n2m9zosna6">
              <a href="mailto:info@yetudesignlab.com" className="flex items-center gap-3 hover:text-[#0000FE]" data-id="element-67" data-mp="3qazo2x4nlfrz">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="335ph784d1bq" />
                info@yetudesignlab.com
              </a>
              <a href="tel:0701922299" className="flex items-center gap-3 hover:text-[#0000FE]" data-id="element-69" data-mp="huwhkupa1x58">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="qt015lgpcjue" />
                0701 922 299
              </a>
              <a href="https://maps.google.com/?q=Kilimani,+Nairobi,+Kenya" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-[#0000FE]" data-id="element-71" data-mp="msxzhcayvqf4">
                <MapPinIcon className="mt-0.5 h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="13tammc3nxw66" />
                Kilimani, Nairobi, Kenya
              </a>
            </address>
          </div>

          <ContactForm data-id="element-73" data-mp="18lbttjlz4wpc" />
        </div>
      </section>

      <footer className="relative z-10 w-full bg-black px-5 py-16 lg:px-8" data-id="element-74" data-mp="1cm45skm8dfpb">
        <div className="mx-auto w-full max-w-shell" data-id="element-75" data-mp="1hkp42ehx9pb4">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-76" data-mp="1hj4b2tb9aefd">
            {/* Left Column */}
            <div className="flex flex-col gap-6 lg:col-span-5" data-id="element-77" data-mp="1mkbk0vp4xjnm">
              <Link to="/" aria-label="Yetu Design Lab home" className="flex items-center gap-3" data-id="element-78" data-mp="1rjemq9hn7dsf">
                <img src="https://cdn.magicpatterns.com/uploads/jd9qFfVjZcYGWGRXhrYTYD/Full_color.png" alt="Yetu Design Lab" className="h-12 w-auto object-contain" data-id="element-79" data-mp="3oboppmyxfvkq" />
              </Link>
              <p className="max-w-sm text-sm leading-relaxed text-[#939598]" data-id="element-80" data-mp="2ah86t0ymzixm">
                Yetu Design Lab is a global UI/UX design agency that boosts brand
                value with user-friendly, effective designs for web, mobile, and
                SaaS platforms.
              </p>
              <div className="mt-4" data-id="element-81" data-mp="1wpjtiucniof2">
                <p className="mb-3 text-sm font-semibold text-white" data-id="element-82" data-mp="2tdpsp1qt0oly">
                  Let's Work Together
                </p>
                <a href="#contact" className="inline-flex items-center gap-3 text-lg font-semibold text-[#0000FE] transition-opacity hover:opacity-80" data-id="element-83" data-mp="2pdfqm064uicd">
                  Book Free Consultation
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0000FE] text-white" data-id="element-84" data-mp="2fgkq5bqau7vg">
                    <ArrowUpRightIcon size={20} data-id="element-85" data-mp="13zb9sy2gvvyd" />
                  </span>
                </a>
              </div>
            </div>

            {/* Middle Column - Services */}
            <div className="lg:col-span-4" data-id="element-86" data-mp="2rtmx8fasqt6m">
              <h3 className="mb-6 font-semibold text-white" data-id="element-87" data-mp="2wmpouhw0jsk6">Services</h3>
              <div className="grid grid-cols-2 gap-x-4 gap-y-4" data-id="element-88" data-mp="2iv1ccdhur22o">
                <div className="flex flex-col gap-4" data-id="element-89" data-mp="2iwvzzzkid8ag">
                  {['Branding', 'UI/UX Design', 'Web Development', 'SEO'].map(s => <a key={s} href="#services" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-90" data-mp="3bkrvj0yccu5n">
                        {s}
                      </a>)}
                </div>
                <div className="flex flex-col gap-4" data-id="element-91" data-mp="36issxtafe19r">
                  {['Google Ads', 'Meta Ads', 'Social Media Management', 'Digital Strategy'].map(s => <a key={s} href="#services" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-92" data-mp="1nkwi673b58fv">
                      {s}
                    </a>)}
                </div>
              </div>
            </div>

            {/* Right Column - Case Studies */}
            <div className="lg:col-span-3" data-id="element-93" data-mp="13xgo69mnqjmw">
              <h3 className="mb-6 font-semibold text-white" data-id="element-94" data-mp="13yi3wrembuay">Case Studies</h3>
              <div className="flex flex-col gap-4" data-id="element-95" data-mp="zxelbx56rk61">
                {['FlowKey Labs', 'Novacloud Solutions', 'HF Whizz Mobile App', 'Taartu'].map(s => <a key={s} href="#work" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-96" data-mp="18v8ex0bkfzpi">
                    {s}
                  </a>)}
              </div>
            </div>
          </div>

          <div className="mt-16 flex flex-col items-center justify-between border-t border-white/10 pt-8 sm:flex-row" data-id="element-97" data-mp="2l9qejpwitz9t">
            <p className="text-sm text-[#939598]" data-id="element-98" data-mp="2pzx3jquy3lsl">
              Yetu Design Lab {new Date().getFullYear()}
            </p>
            <div className="mt-4 flex gap-6 sm:mt-0" data-id="element-99" data-mp="2uy8bfw1ojm86">
              <a href="#top" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-100" data-mp="1xbrif2zzbus8">
                LinkedIn
              </a>
              <a href="#top" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-101" data-mp="22cp5ntzujf0l">
                Instagram
              </a>
              <a href="#top" className="text-sm text-[#939598] transition-colors hover:text-white" data-id="element-102" data-mp="2b97naa2mnghv">
                Facebook
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>;
}